import { definePluginClient } from "../../client/builder";
import { generationPluginClient } from "../generation/client";
import type { memoriesPlugin } from "./server";

export const memoriesPluginClient = definePluginClient<typeof memoriesPlugin>("memories")
  .dependencies([generationPluginClient])
  .class((_) => class {});
